import React from 'react';
import { useSelector } from 'react-redux';
import DefaultSummary from './DefaultSummary.js';
const SMSSummary = (props) => {
    const lang = useSelector((s) => s.lang);
    const sms = props.interaction.details;
    const textParts = sms.text && sms.text.split('\n');
    const metaData = [
        { header: lang.interactions.from, body: sms.from },
        {
            header: lang.interactions.to,
            body: (React.createElement(React.Fragment, null,
                React.createElement("span", { style: { fontSize: '.8em' } }, sms.countryCode),
                ' ',
                sms.number)),
        },
    ];
    return (React.createElement(DefaultSummary, { ...props, metaData: metaData },
        React.createElement("p", null, textParts &&
            textParts.map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                item,
                index !== textParts.length - 1 && React.createElement("br", null)))))));
};
export default SMSSummary;
//# sourceMappingURL=SMSSummary.js.map